import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, FolderTree, Users, ShieldCheck, ClipboardList, Banknote, ReceiptText, Star, Settings } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  ["/admin", "Dasbor", LayoutDashboard, "dashboard"],
  ["/admin/kategori", "Kategori & Kota", FolderTree, "catalog"],
  ["/admin/pengguna", "Pengguna", Users, "users"],
  ["/admin/verifikasi", "Verifikasi", ShieldCheck, "verification"],
  ["/admin/pesanan", "Pesanan & Komplain", ClipboardList, "orders"],
  ["/admin/pencairan", "Pencairan", Banknote, "payouts"],
  ["/admin/transaksi", "Transaksi", ReceiptText, "transactions"],
  ["/admin/ulasan", "Ulasan", Star, "reviews"],
  ["/admin/pengaturan", "Pengaturan", Settings, "settings"],
];

export const AdminLayout = () => (
  <div className="container-page grid gap-8 py-8 lg:grid-cols-[230px_1fr]" data-testid="admin-layout">
    <aside className="lg:sticky lg:top-24 lg:self-start">
      <p className="eyebrow mb-3 px-3">Panel Admin</p>
      <nav className="flex gap-1 overflow-x-auto lg:flex-col">
        {NAV.map(([to, label, Icon, id]) => (
          <NavLink key={to} to={to} end={to === "/admin"} data-testid={`admin-nav-${id}`}
            className={({ isActive }) => cn("flex shrink-0 items-center gap-2.5 rounded-xl px-3 py-2 text-sm font-medium transition-colors",
              isActive ? "bg-teal-700 text-white" : "text-stone-600 hover:bg-stone-100")}>
            <Icon className="h-4 w-4" /> {label}
          </NavLink>
        ))}
      </nav>
    </aside>
    <section className="min-w-0"><Outlet /></section>
  </div>
);

export const AdminHead = ({ title, desc, children }) => (
  <div className="mb-6 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-stone-900 sm:text-3xl">{title}</h1>
      {desc && <p className="mt-1 text-sm text-stone-500">{desc}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Table = ({ cols, rows, empty = "Tidak ada data", testId = "admin-table" }) => (
  <div className="card-soft overflow-x-auto" data-testid={testId}>
    <table className="w-full min-w-[640px] text-sm">
      <thead>
        <tr className="border-b border-stone-200 text-left text-xs uppercase tracking-wider text-stone-500">
          {cols.map((c) => <th key={c} className="px-4 py-3 font-semibold">{c}</th>)}
        </tr>
      </thead>
      <tbody className="divide-y divide-stone-100">
        {rows.length === 0 ? <tr><td colSpan={cols.length} className="px-4 py-10 text-center text-stone-500">{empty}</td></tr> : rows}
      </tbody>
    </table>
  </div>
);

export const Td = ({ children, className }) => <td className={cn("px-4 py-3 align-top text-stone-700", className)}>{children}</td>;

export const FilterSelect = ({ value, onChange, options, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className="h-10 rounded-xl border border-stone-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/40">
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);
